import * as React from "react";
import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { isTablet } from "react-device-detect";
import SearchIcon from "@mui/icons-material/Search";
import Divider from "@mui/material/Divider";
import { InputBase } from "@mui/material";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Modal from "@mui/material/Modal";
import { Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import { Checkbox } from "@mui/material";
import { FormGroup, FormControl, FormLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";
import { MstaButton, BackButton } from "../../Functions/Style/ButtonStyle";
import { lightBlue, yellow } from "@mui/material/colors";
import EastIcon from "@mui/icons-material/East";
import CatalogueMenu from "./CatalogueMenu";
import FormControlLabel from "@mui/material/FormControlLabel";
import SearchQuery from "../../Modules/Search/SearchQuery";
import { CaseCardType } from "../../Modules/ViewCase/CaseCard";
import { sex, sites, organs, modals, ages } from "../../Environment/Config";
import { useLocation } from "react-router-dom";
import MstaStyle from "../../Functions/Style/style.module.css";
import TuneIcon from "@mui/icons-material/Tune";
import CatalogueTab from "./CatalogueTab";

export default function Search() {
  const organTitle = [
    { id: "運動器", value: organs.slice(0, 3) },
    { id: "神経", value: organs.slice(3, 6) },
    { id: "特殊感覚", value: organs.slice(6, 9) },
    { id: "内分泌", value: organs.slice(9, 12) },
    { id: "リンパ・循環器", value: organs.slice(12, 15) },
    { id: "胸部・呼吸器", value: organs.slice(15, 22) },
    { id: "消化器", value: organs.slice(22, 35) },
    { id: "泌尿器", value: organs.slice(35, 40) },
    { id: "生殖器", value: organs.slice(40) },
  ];

  const { width, height } = useWindowDimensions();
  const searching = useLocation().search;

  const queryWord = new URLSearchParams(searching);
  const keyword = queryWord.get("keyword");

  const [searchWord, setSearchWord] = React.useState(keyword ? keyword : "");
  const [composing, setComposition] = React.useState(false);
  const [update, setUpdate] = React.useState(false);
  const [cases, setCases] = React.useState<CaseCardType[]>([]);
  const [searchExpanded, setSearchExpanded] = React.useState(false);
  const [organExpanded, setOrganExpanded] = React.useState(false);
  const [filterSex, setFilterSex] = React.useState<string[]>([]);
  const [filterAge, setFilterAge] = React.useState<string[]>([]);
  const [filterSite, setFilterSite] = React.useState<string[]>([]);
  const [filterOrgan, setFilterOrgan] = React.useState<string[]>([]);
  const [filterModality, setFilterModality] = React.useState<string[]>([]);

  const navigate = useNavigate();

  const handleExpandClick = () => setSearchExpanded(!searchExpanded);

  const startComposition = () => setComposition(true);
  const endComposition = () => setComposition(false);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      if (composing === false) {
        // Perform search or any other desired action
        getQuery();
        navigate(`?keyword=${searchWord}`);
      }
    }
  };

  const handleOpenLink = (url: string) => {
    const toUrl = url;
    navigate(toUrl);
  };

  const handleChangeArrayTarget = (
    element: string,
    array: string[],
    name: string
  ) => {
    if (array.includes(element)) {
      const found = array.findIndex((item) => item === element);
      array.splice(found, 1);
    } else {
      array.push(element);
    }
    if (name === "sex") {
      setFilterSex(array);
    } else if (name === "age") {
      setFilterAge(array);
    } else if (name === "site") {
      setFilterSite(array);
    } else if (name === "organ") {
      setFilterOrgan(array);
    } else if (name === "modality") {
      setFilterModality(array);
    }
    setUpdate(!update);
    //props.getContentsData(array, 'site')
  };

  const resetCheckBox = () => {
    setFilterSex([]);
    setFilterAge([]);
    setFilterSite([]);
    setFilterOrgan([]);
    setFilterModality([]);
  };

  const getQuery = () => {
    setCases([]);
    SearchQuery({
      keyword: searchWord,
      sex: filterSex,
      ages: filterAge,
      modality: filterModality,
      siteTags: filterSite,
      organTags: filterOrgan,
    }).then((result: CaseCardType[]) => {
      if (result.length > 0) {
        setCases(result);
      }
    });
  };

  const handleDelete = (
    setFilter: React.Dispatch<React.SetStateAction<string[]>>,
    deleteElement: string
  ): void => {
    setFilter((prev) => prev.filter((item) => item !== deleteElement));
  };

  const getDisplayFromValue = (
    filterList: {
      value: string;
      display: string;
    }[],
    value: string
  ): string => {
    const filterObject = filterList.find((item) => item.value === value);
    return filterObject ? filterObject.display : value;
  };

  React.useEffect(() => {
    getQuery();
  }, []);

  return (
    <React.Fragment>
      <CatalogueTab initialTab={0}/>
      <div className={MstaStyle.mstaItemCenter}>
        <Grid
          container
          sx={{ mt: 3, minHeight: "95vh", minWidth: "100vw" }}
          justifyContent="center"
        >
          {/* {width > 500 && isTablet === false ? (
            <Grid style={{ position: "fixed" }}>
              <Tooltip title="戻る">
                <BackButton
                  variant="contained"
                  sx={{ ml: 3, mt: 0.5 }}
                  onClick={() => {
                    handleOpenLink("/");
                  }}
                >
                  <ArrowBackIcon />
                </BackButton>
              </Tooltip>
            </Grid>
          ) : (
            <div></div>
          )} */}

          <Container sx={{ py: 1 }}>
            <Typography
              gutterBottom
              align="left"
              variant="h4"
              id="normal"
              fontFamily={MstaFontFamily}
            >
              気になる症例を検索
            </Typography>
            <Divider
              sx={{
                borderBottomWidth: 1.5,
                borderColor: "black",
                mt: 1,
                mb: 4,
              }}
            />
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              display="grid"
            >
              <Box sx={{ py: 2 }}>
                <Grid display={{ md: "flex", xs: "grid" }} alignItems="center">
                  <Grid onKeyDown={handleKeyPress}>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        my: 2,
                        display: "flex",
                        alignItems: "center",
                        minWidth: { xs: 300, sm: 450, md: 650 },
                        minHeight: { xs: 35, sm: 40, md: 50 },
                      }}
                    >
                      <SearchIcon
                        sx={{ fontSize: { md: 40, xs: 30 }, color: "gray" }}
                      />
                      <InputBase
                        sx={{
                          ml: 1,
                          flex: 1,
                          fontSize: { md: 24, xs: 16 },
                          fontFamily: MstaFontFamily,
                        }}
                        placeholder="症例を検索する"
                        inputProps={{ "aria-label": "search" }}
                        onCompositionStart={startComposition}
                        onCompositionEnd={endComposition}
                        value={searchWord}
                        onChange={(event) => {
                          setSearchWord(event.target.value);
                        }}
                      />
                      <Divider
                        orientation="vertical"
                        variant="middle"
                        flexItem
                      />
                      <Tooltip title="詳細検索">
                        <IconButton
                          type="button"
                          sx={{ p: "10px" }}
                          aria-label="search"
                          onClick={handleExpandClick}
                        >
                          <TuneIcon
                            sx={{ fontSize: { md: 40, xs: 30 }, color: "gray" }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Paper>
                  </Grid>
                  {/* <Button
                    variant="contained"
                    sx={{
                      fontSize: { md: 20, xs: 14 },
                      width: { md: 100, xs: 80 },
                      height: { md: 60, xs: 40 },
                      backgroundColor: yellow[400],
                      color: "black",
                      fontFamily: MstaFontFamily,
                      "&:hover": {
                        backgroundColor: yellow[600],
                      },
                    }}
                    onClick={getQuery}
                  >
                    検索
                  </Button> */}
                </Grid>

                <Grid
                  item
                  display="flex"
                  sx={{
                    gap: 0.4,
                    maxWidth: { xs: 308, sm: 458, md: 658 },
                    flexWrap: "wrap",
                  }}
                >
                  {filterSex.map((element) => (
                    <Chip
                      label={getDisplayFromValue(sex, element)}
                      variant="outlined"
                      onDelete={() => handleDelete(setFilterSex, element)}
                    />
                  ))}
                  {filterAge.map((element) => (
                    <Chip
                      label={getDisplayFromValue(ages, element)}
                      variant="outlined"
                      onDelete={() => handleDelete(setFilterAge, element)}
                    />
                  ))}
                  {filterModality.map((element) => (
                    <Chip
                      label={element}
                      variant="outlined"
                      onDelete={() => handleDelete(setFilterModality, element)}
                    />
                  ))}
                  {filterSite.map((element) => (
                    <Chip
                      label={element}
                      variant="outlined"
                      onDelete={() => handleDelete(setFilterSite, element)}
                    />
                  ))}
                  {filterOrgan.map((element) => (
                    <Chip
                      label={element}
                      variant="outlined"
                      onDelete={() => handleDelete(setFilterOrgan, element)}
                    />
                  ))}
                </Grid>
              </Box>

              {/*<Grid 
                  justifyContent="center"
                  alignItems="center"
                  sx={{ display: 'flex',mt:1,mb:1}}>
                    
                    <ExpandMore
                        expand={searchExpanded}
                        onClick={handleExpandClick}
                        aria-expanded={searchExpanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon sx={{ color: 'black',fontSize:20}}/>
                    </ExpandMore>         
                </Grid>*/}
              <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                <Box sx={{ maxWidth: { xs: 308, sm: 458, md: 658 }, mt: 1 }}>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableBody>
                        <TableRow
                          key="ages"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{
                              bgcolor: lightBlue[300],
                              fontSize: { md: 16, xs: 14 },
                              fontWeight: "bold",
                            }}
                            component="th"
                            scope="row"
                          >
                            {"性別"}
                          </TableCell>
                          <TableCell align="right">
                            <FormGroup aria-label="position" row>
                              {sex.map(
                                (element: {
                                  display: string;
                                  value: string;
                                }) => {
                                  return (
                                    <FormGroup aria-label="position" row>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              filterSex.includes(
                                                element.value
                                              ) === true
                                            }
                                            onClick={() =>
                                              handleChangeArrayTarget(
                                                element.value,
                                                filterSex,
                                                "sex"
                                              )
                                            }
                                          />
                                        }
                                        label={
                                          <Typography
                                            sx={{
                                              fontSize: {
                                                md: 16,
                                                xs: 14,
                                              },
                                            }}
                                          >
                                            {element.display}
                                          </Typography>
                                        }
                                        labelPlacement="end"
                                      />
                                    </FormGroup>
                                  );
                                }
                              )}
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          key="ages"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{
                              bgcolor: lightBlue[300],
                              fontSize: { md: 16, xs: 14 },
                              fontWeight: "bold",
                            }}
                            component="th"
                            scope="row"
                          >
                            {"年代"}
                          </TableCell>
                          <TableCell align="right">
                            <FormGroup aria-label="position" row>
                              {ages.map(
                                (element: {
                                  display: string;
                                  value: string;
                                }) => {
                                  return (
                                    <FormControlLabel
                                      key={element.display}
                                      control={
                                        <Checkbox
                                          checked={
                                            filterAge.includes(
                                              element.value
                                            ) === true
                                          }
                                          onClick={() =>
                                            handleChangeArrayTarget(
                                              element.value,
                                              filterAge,
                                              "age"
                                            )
                                          }
                                        />
                                      }
                                      label={
                                        <Typography
                                          sx={{
                                            fontSize: {
                                              md: 16,
                                              xs: 14,
                                            },
                                          }}
                                        >
                                          {element.display}
                                        </Typography>
                                      }
                                      labelPlacement="end"
                                    />
                                  );
                                }
                              )}
                            </FormGroup>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          key="modality"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{
                              bgcolor: lightBlue[300],
                              fontSize: { md: 16, xs: 14 },
                              fontWeight: "bold",
                            }}
                            component="th"
                            scope="row"
                          >
                            {"Modality"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <FormGroup aria-label="position" row>
                              {modals.map((element: string) => {
                                return (
                                  <FormControlLabel
                                    key={element}
                                    control={
                                      <Checkbox
                                        checked={
                                          filterModality.includes(element) ===
                                          true
                                        }
                                        onClick={() =>
                                          handleChangeArrayTarget(
                                            element,
                                            filterModality,
                                            "modality"
                                          )
                                        }
                                      />
                                    }
                                    label={
                                      <Typography
                                        sx={{
                                          fontSize: {
                                            md: 16,
                                            xs: 14,
                                          },
                                        }}
                                      >
                                        {element}
                                      </Typography>
                                    }
                                    labelPlacement="end"
                                  />
                                );
                              })}
                            </FormGroup>
                          </TableCell>
                        </TableRow>

                        <TableRow
                          key="sites"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{
                              bgcolor: lightBlue[300],
                              fontSize: { md: 16, xs: 14 },
                              fontWeight: "bold",
                            }}
                            component="th"
                            scope="row"
                          >
                            {"部位"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <FormGroup aria-label="position" row>
                              {sites.map((element: string) => {
                                return (
                                  <FormControlLabel
                                    key={element}
                                    control={
                                      <Checkbox
                                        checked={
                                          filterSite.includes(element) === true
                                        }
                                        onClick={() =>
                                          handleChangeArrayTarget(
                                            element,
                                            filterSite,
                                            "site"
                                          )
                                        }
                                      />
                                    }
                                    label={
                                      <Typography
                                        sx={{
                                          fontSize: {
                                            md: 16,
                                            xs: 14,
                                          },
                                        }}
                                      >
                                        {element}
                                      </Typography>
                                    }
                                    labelPlacement="end"
                                  />
                                );
                              })}
                            </FormGroup>
                          </TableCell>
                        </TableRow>

                        <TableRow
                          key="organs"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{
                              bgcolor: lightBlue[300],
                              fontSize: { md: 16, xs: 14 },
                              fontWeight: "bold",
                            }}
                            component="th"
                            scope="row"
                          >
                            {"臓器"}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ fontSize: 16, cursor: "pointer" }}
                            onClick={() => setOrganExpanded(!organExpanded)}
                          >
                            {"臓器を選ぶ"}
                            <IconButton aria-label="expand row" size="small">
                              {organExpanded ? (
                                <ExpandLessIcon />
                              ) : (
                                <ExpandMoreIcon />
                              )}
                            </IconButton>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          key="ages"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{ bgcolor: lightBlue[300] }}
                            component="th"
                            scope="row"
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                          ></TableCell>

                          <TableCell
                            component="th"
                            scope="row"
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                          >
                            <Collapse
                              in={organExpanded}
                              timeout="auto"
                              unmountOnExit
                            >
                              {organTitle.map(
                                (
                                  element: {
                                    id: string;
                                    value: { name: string }[];
                                  },
                                  index: number,
                                  array: any
                                ) => {
                                  const isFirstElement = index === 0;
                                  const isLastElement =
                                    index === array.length - 1;

                                  return (
                                    <div
                                      key={element.id}
                                      style={{
                                        marginTop: isFirstElement
                                          ? "16px"
                                          : undefined,
                                        marginBottom: isLastElement
                                          ? "16px"
                                          : undefined,
                                      }}
                                    >
                                      <Typography
                                        variant="subtitle1"
                                        textAlign="left"
                                        gutterBottom
                                        sx={{ fontSize: { md: 16, xs: 14 } }}
                                      >
                                        {element.id}
                                      </Typography>
                                      <FormGroup aria-label="position" row>
                                        {element.value.map(
                                          (element: { name: string }) => (
                                            <FormControlLabel
                                              key={element.name}
                                              control={
                                                <Checkbox
                                                  checked={
                                                    filterOrgan.includes(
                                                      element.name
                                                    ) === true
                                                  }
                                                  onClick={() =>
                                                    handleChangeArrayTarget(
                                                      element.name,
                                                      filterOrgan,
                                                      "organ"
                                                    )
                                                  }
                                                />
                                              }
                                              label={
                                                <Typography
                                                  sx={{
                                                    fontSize: {
                                                      md: 16,
                                                      xs: 14,
                                                    },
                                                  }}
                                                >
                                                  {element.name}
                                                </Typography>
                                              }
                                              labelPlacement="end"
                                            />
                                          )
                                        )}
                                      </FormGroup>
                                      {!isLastElement ? (
                                        <Divider sx={{ mt: 1, mb: 2 }} />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 3,
                      my: 2,
                    }}
                  >
                    <Button variant="text" onClick={resetCheckBox}>
                      リセット
                    </Button>
                    <MstaButton
                      variant="contained"
                      sx={{ fontSize: 16, height: 36 }}
                      onClick={getQuery}
                    >
                      検索
                    </MstaButton>
                  </Grid>
                </Box>
              </Collapse>
            </Grid>

            <CatalogueMenu cases={cases}></CatalogueMenu>
          </Container>
        </Grid>
      </div>
    </React.Fragment>
  );
}
